module.exports = {
	"articleTitle1": "Best Chinese: TK WU",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "TK WU",
	"articleLink1": "https://www.michigandaily.com/arts/best-chinese-tk-wu",
	"articleLink2": "https://www.michigandaily.com/news/new-fast-casual-asian-restaurant-opens-east-liberty-street",
	"articleSnippet1": "Apr 6, 2014 ... Walking briskly down East Liberty searching for a worthy lunch destination, I \nalmost missed TK WU entirely. It's located in a small, ...",
	"articleSnippet2": "Dec 5, 2013 ... Tamaki joins several similar restaurants on East Liberty Street that specialize in \nAsian cuisine, such as Tomukun Noodle Bar and TK Wu.",
	"foodRecommendations": [
		{
			"text": "It's a nice sitdown Chinese restaurant. They have good bubble tea.",
			"person": "Marisa Iaderosa"
		}
	],
	"articleTitle2": "Tamaki serves up fusion of Asian flavors",
	"address": "510 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279185,
		"lng": -83.742561
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/tkwu.json
// module id = 988
// module chunks = 0